// extracted by mini-css-extract-plugin
export default {"banner-container":"PageBanner_banner-container__Eta7o","title":"PageBanner_title__PpE4r"};